import axios from "axios";
import { useContext } from "react";
import useSWR from "swr";
import { AuthContext } from "../../../context/AuthContext";
import { ADMIN_API_URL } from "../../../utils/env";

export interface IMegaRewardsAccount {
  account: string;
  username: string;
  staking_tier: string;
  duration_tier: string;
  current_staked_amount: string;
  required_staked_amount: string;
  total_volume: string;
  current_unlock_epoch: number;
  required_snapshot_epoch: number;
  has_snapshot_stake: boolean;
  is_snapshot_eligible: boolean;
  reject_reasons: string[];
  error?: string;
  // Optional during rollout, before the backend supplies reward estimates.
  ranking?: number;
  expected_reward_pool_percentage?: string | null;
  expected_reward_usdc?: string | null;
  is_capped?: boolean;
}

export interface IMegaRewardsResponse {
  summary: {
    total_stakers: number;
    candidates: number;
    snapshot_eligible_candidates: number;
    volume_query_errors: number;
  };
  rows: IMegaRewardsAccount[];
  pool_usdc?: string;
  volume_window_start_epoch?: number;
  volume_window_end_epoch?: number;
  undistributed_pool_percentage?: string | null;
  undistributed_reward_usdc?: string | null;
}

export const useMegaRewards = () => {
  const { tokenId, queryConfig } = useContext(AuthContext);
  const endpoint = ADMIN_API_URL("lp-revenue/eligibility-debug");

  return useSWR<IMegaRewardsResponse, Error>(
    tokenId ? [endpoint, tokenId] : null,
    async () => {
      const { data } = await axios.get<IMegaRewardsResponse>(
        endpoint,
        queryConfig()
      );
      if (!data || !Array.isArray(data.rows) || !data.summary) {
        throw new Error("Invalid Mega Rewards response");
      }
      return data;
    },
    {
      refreshInterval: 300000,
      dedupingInterval: 60000,
      revalidateOnFocus: false,
    }
  );
};
